import * as capSvc from "./services/internalService.js";

const StateProvinces = [
  {
    Id: 1,
    Code: "AL",
    Name: "Alabama"
  },
  {
    Id: 2,
    Code: "AK",
    Name: "Alaska"
  },
  {
    Id: 4,
    Code: "AZ",
    Name: "Arizona"
  },
  {
    Id: 5,
    Code: "AR",
    Name: "Arkansas"
  },
  {
    Id: 7,
    Code: "CA",
    Name: "California"
  },
  {
    Id: 8,
    Code: "CO",
    Name: "Colorado"
  },
  {
    Id: 9,
    Code: "CT",
    Name: "Connecticut"
  },
  {
    Id: 10,
    Code: "DE",
    Name: "Delaware"
  },
  {
    Id: 11,
    Code: "DC",
    Name: "District of Columbia"
  },
  {
    Id: 13,
    Code: "FL",
    Name: "Florida"
  },
  {
    Id: 15,
    Code: "GA",
    Name: "Georgia"
  },
  {
    Id: 16,
    Code: "HI",
    Name: "Hawaii"
  },
  {
    Id: 17,
    Code: "ID",
    Name: "Idaho"
  },
  {
    Id: 18,
    Code: "IL",
    Name: "Illinois"
  },
  {
    Id: 19,
    Code: "IN",
    Name: "Indiana"
  },
  {
    Id: 20,
    Code: "IA",
    Name: "Iowa"
  },
  {
    Id: 21,
    Code: "KS",
    Name: "Kansas"
  },
  {
    Id: 23,
    Code: "KY",
    Name: "Kentucky"
  },
  {
    Id: 24,
    Code: "LA",
    Name: "Louisiana"
  },
  {
    Id: 25,
    Code: "ME",
    Name: "Maine"
  },
  {
    Id: 27,
    Code: "MD",
    Name: "Maryland"
  },
  {
    Id: 28,
    Code: "MA",
    Name: "Massachusetts"
  },
  {
    Id: 29,
    Code: "MI",
    Name: "Michigan"
  },
  {
    Id: 30,
    Code: "MN",
    Name: "Minnesota"
  },
  {
    Id: 31,
    Code: "MS",
    Name: "Mississippi"
  },
  {
    Id: 32,
    Code: "MO",
    Name: "Missouri"
  },
  {
    Id: 33,
    Code: "MT",
    Name: "Montana"
  },
  {
    Id: 34,
    Code: "NE",
    Name: "Nebraska"
  },
  {
    Id: 35,
    Code: "NV",
    Name: "Nevada"
  },
  {
    Id: 37,
    Code: "NH",
    Name: "New Hampshire"
  },
  {
    Id: 38,
    Code: "NJ",
    Name: "New Jersey"
  },
  {
    Id: 39,
    Code: "NM",
    Name: "New Mexico"
  },
  {
    Id: 40,
    Code: "NY",
    Name: "New York"
  },
  {
    Id: 42,
    Code: "NC",
    Name: "North Carolina"
  },
  {
    Id: 43,
    Code: "ND",
    Name: "North Dakota"
  },
  {
    Id: 47,
    Code: "OH",
    Name: "Ohio"
  },
  {
    Id: 48,
    Code: "OK",
    Name: "Oklahoma"
  },
  {
    Id: 50,
    Code: "OR",
    Name: "Oregon"
  },
  {
    Id: 52,
    Code: "PA",
    Name: "Pennsylvania"
  },
  {
    Id: 54,
    Code: "PR",
    Name: "Puerto Rico"
  },
  {
    Id: 56,
    Code: "RI",
    Name: "Rhode Island"
  },
  {
    Id: 59,
    Code: "SC",
    Name: "South Carolina"
  },
  {
    Id: 60,
    Code: "SD",
    Name: "South Dakota"
  },
  {
    Id: 61,
    Code: "TN",
    Name: "Tennessee"
  },
  {
    Id: 62,
    Code: "TX",
    Name: "Texas"
  },
  {
    Id: 63,
    Code: "UT",
    Name: "Utah"
  },
  {
    Id: 64,
    Code: "VT",
    Name: "Vermont"
  },
  {
    Id: 65,
    Code: "VA",
    Name: "Virginia"
  },
  {
    Id: 67,
    Code: "WA",
    Name: "Washington"
  },
  {
    Id: 68,
    Code: "WV",
    Name: "West Virginia"
  },
  {
    Id: 69,
    Code: "WI",
    Name: "Wisconsin"
  },
  {
    Id: 70,
    Code: "WY",
    Name: "Wyoming"
  }
];
let brandId;

console.log('brand1: ' + sessionStorage.getItem('brandId'));
brandId = capSvc.getBrand();
console.log('brand2: ' + sessionStorage.getItem('brandId'));
window.duplicateWorkHistory = duplicateWorkHistory;
window.duplicateEducationHistory = duplicateEducationHistory;
window.deleteWorkClone = deleteWorkClone;
window.deleteSchoolClone = deleteSchoolClone;
window.validate = validate;
window.returnToSearch = returnToSearch
window.checkEligibilityInput = checkEligibilityInput;
window.selectRadioBtn = selectRadioBtn

let resumeuploaded = false;
let capFileStoreId = 0
let wrkHistory = []
let educationHistory = []
let candidate = {
  applicationSource: null,
  jobId: 0,
  peopleSoftId: 0,
  firstName: null,
  middleName: null,
  noMiddleName: null,
  lastName: null,
  emailAddress: null,
  address1: null,
  address2: null,
  city: null,
  stateProvince: null,
  postalCode: null,
  phone: null,
  adSourceId: null,
  eligibilityFlag: true,
  ageFlag: true,
  agreementAcknowledgement: true,
  previouslyEmployedFlag: true,
  linkedInUrl: null,
  previousAffiliate: null,
  resumeFileStoreId: 0,
  nonCompete: true,
  gender: null,
  genderIdentity: null,
  ethnicityId: null,
  veteranStatusId: null,
  disabilityId: null,
  referredBy: null,
  workHistory: [
    {
      internalCandidateId: null,
      companyName: null,
      city: null,
      stateProvince: null,
      postalCode: null,
      phoneNumber: null,
      jobTitle: null,
      jobDescription: null,
      startDate: null,
      endDate: null,
      supervisorName: null,
      reasonForLeavingComments: null,
      contactFlag: null,
      currentEmployerFlag: null,
      tempAgency: null,
      reasonId: null
    }
  ],
  educationHistory: [
    {
      internalCandidateId: null,
      schoolName: null,
      educationLevelId: null,
      courseOfStudy: null,
      degree: null,
      graduated: null
    }
  ]
}
let candidateId = 0
let workCounter = 0
let educationCounter = 0

// Boostrap form validation - common messages **begin
const phoneMsgHtml = `<div id="phoneMsgDisplay-0" class="invalid-feedback">Please enter a phone number</div>`
const cityMsgHtml = `<div class="invalid-feedback">Please enter a city</div>`
const statesProvinceMsgHtml = `<div class="invalid-feedback">Please select a state</div>`
const ZipPostalMsgHtml = `<div class="invalid-feedback">Please enter a valid zip code</div>`
const selectMsgHtml = `<div class="invalid-feedback" >Please select yes or no</div>`

// Boostrap form validation - common messages **end
window.onload = function () {
  $("body").show();
  document.title = 'Application for ' + sessionStorage.getItem("jobTitle");
  const pageTitle = document.getElementById("pageTitle")
  pageTitle.innerHTML = `
      <div id="headerRow" class="d-flex justify-content-center">
          <a id="homePage" href="${sessionStorage.getItem('homePageUrl')}">
            <img id="applicationLogoHeader" alt="${sessionStorage.getItem('brandName')} Logo" class="ml-auto w-100" src="${sessionStorage.getItem('logoImageUrl')}" >
          </a>
        </div>
  ${sessionStorage.getItem('headerHtml')}
    <div class="d-flex flex-column flex-wrap font-weight-bolder text-center mb-2" style="display: inline-block">
        <h4 class="my-2" style="display: inline-block">Please submit your application for the position of: </h4>
        <h3 class="my-1" style="display: inline-block">${sessionStorage.getItem("jobTitle")}</h3>
    </div>`

  const nameField = document.querySelector("input");

  nameField.addEventListener("input", () => {
    nameField.setCustomValidity("");
    nameField.checkValidity();
    console.log(nameField.checkValidity());
  });

  nameField.addEventListener("invalid", () => {
    nameField.setCustomValidity("Please fill in your First Name.");
  });

  const statesDropDown = document.getElementById('statesProvince')
  StateProvinces.map(stateProvince => {
    const option = document.createElement('option')
    option.text = stateProvince.Name
    option.value = stateProvince.Code
    statesDropDown.options.add(option)
  })

  const jobStatesProvince = document.getElementById('jobStatesProvince-0')
  StateProvinces.map(stateProvince => {
    const option = document.createElement('option')
    option.text = stateProvince.Name
    option.value = stateProvince.Code
    jobStatesProvince.options.add(option)
  })

  wrkHistory[workCounter] = $('#previousEmployer-' + workCounter)[0].elements
  educationHistory[educationCounter] = $('#previousEducation-' + educationCounter)[0].elements

  removePreloader();

  // Boostrap form validation - onload **begin
  const headElement = document.querySelector('head');
  const bootstrapHtml = `<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
                            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">`
  $(headElement).append(bootstrapHtml);
  // const jqueryHtml = `<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>`
  // $(headElement).append(jqueryHtml);
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.add("needs-validation");
  formElement.setAttribute('novalidate', '');
  const radioInputs = document.querySelectorAll('input[type="radio"]')
  radioInputs.forEach((input) => {
    input.classList.add('form-check-input')
    $(input).css("position", "relative")
      .css("width", "0.8em")
      .css("height", "0.8em")
      .css("margin-top", "0.5em")
      .css("margin-left", "0.3em")
      .css("border-color", "#626567")
    input.setAttribute('required', '')
  });
  const selectAgeMsgHtml = `<div id="check-age" class="invalid-feedback" >Please select yes to apply</div>`
  const selectAuthMsgHtml = `<div id="check-auth" class="invalid-feedback" >Please select yes to apply</div>`
  const radioLabels = document.querySelectorAll('.radio-style-1-label')
  const authorizedHtml = '<div id="authorizedWarning" className="col-md-12" style="display:none;">\n' +
    '  <p style="color:indianred;font-weight: bold;">All employees must be eligible to\n' +
    '    work in the US</p>\n' +
    '</div>'
  for (let i = 1; i <= radioLabels.length; i++) {
    if (i % 2 > 0) {
      if (i === 1)
        $(radioLabels[i]).after(selectAgeMsgHtml);
      else if (i === 3)
        $(radioLabels[i]).after(selectAuthMsgHtml);
      else
        $(radioLabels[i]).after(selectMsgHtml);
    }
  }
  $('#usAuthorizationVerification').after(authorizedHtml);

  //part 2 remove Cancel element
  const cancelBtn = document.querySelector('.fileinput-cancel-button')
  cancelBtn.remove()
  const removeBtn = document.querySelector('.fileinput-remove-button')
  removeBtn.remove()
  const uploadBtn = document.querySelector('.fileinput-upload-button')
  uploadBtn.remove()

  //part 3 field validation
  const submitRows = document.querySelectorAll('div.row.d-flex.flex-row')
  //alert('submitRows num = ' + submitRows.length)
  if (submitRows.length > 1)
    submitRows[1].classList.remove('row');

  // Personal info fields
  const firstNameMsgHtml = `<div class="invalid-feedback mb-2" >Please enter your first name</div>`
  const firstName = document.querySelector('#firstName')
  $(firstName).after(firstNameMsgHtml);
  const middleNameMsgHtml = `<div class="invalid-feedback" >Please check box below if no middle name</div>`
  const middleName = document.querySelector('#middleName')
  middleName.setAttribute('required', '')
  $(middleName).after(middleNameMsgHtml);
  const lastNameMsgHtml = `<div class="invalid-feedback mb-2">Please enter your last name</div>`
  const lastName = document.querySelector('#lastName')
  $(lastName).after(lastNameMsgHtml);
  const cellOrPhoneNumberMsgHtml1 = `<div id="cellOrPhoneMsg1" class="invalid-feedback">Please enter a cell or phone number</div>`
  const cellNumber = document.querySelector('#cellNumber')
  cellNumber.setAttribute('pattern', '^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$')
  $(cellNumber).after(cellOrPhoneNumberMsgHtml1);
  //const phoneMsgHtml = `<div class="invalid-feedback">Please enter a phone number</div>`
  const cellOrPhoneNumberMsgHtml2 = `<div id="cellOrPhoneMsg2" class="invalid-feedback">Please enter a cell or phone number</div>`
  const phone = document.querySelector('#phoneNumber')
  phone.setAttribute('pattern', '^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$')
  $(phone).after(cellOrPhoneNumberMsgHtml2);
  const emailMsgHtml = `<div class="invalid-feedback mb-2" >Please enter a valid email address</div>`
  const email = document.querySelector('#emailAddress')
  email.setAttribute('pattern', '\\S+@\\S+\\.\\S+')
  email.removeAttribute('onchange')
  email.removeAttribute('onkeyup')
  $(email).after(emailMsgHtml);
  const address1MsgHtml = `<div class="invalid-feedback">Please enter an address</div>`
  const address1 = document.querySelector('#address1')
  $(address1).after(address1MsgHtml);
  // const cityMsgHtml = `<div class="invalid-feedback">Please enter a city</div>`
  const city = document.querySelector('#city')
  $(city).after(cityMsgHtml);
//  const statesProvinceMsgHtml = `<div class="invalid-feedback">Please select a state</div>`
  const statesProvince = document.querySelector('#statesProvince')
  statesProvince.removeAttribute('onchange')
  $(statesProvince).after(statesProvinceMsgHtml);
  // const ZipPostalMsgHtml = `<div class="invalid-feedback">Please enter a zip code</div>`
  const ZipPostal = document.querySelector('#ZipPostal')
  $(ZipPostal).after(ZipPostalMsgHtml);
  $("#affiliatedSource").parents("div.d-flex").addClass('flex-wrap')
  const companyMsgHtml = `<div class="invalid-feedback " style="margin-left: 12rem;">Please select a company</div>`
  const affiliatedSource = document.querySelector('#affiliatedSource')
  $(affiliatedSource).after(companyMsgHtml);
  affiliatedSource.removeAttribute("onchange")
  const adSourceMsgHtml = `<div class="invalid-feedback text-left">Please select a source</div>`
  const adSource = document.querySelector('#adSource')
  $(adSource).after(adSourceMsgHtml);
  adSource.removeAttribute("onchange")

  // Self Identity fields
  const selectOneMsgHtml = `<div class="invalid-feedback">Please select one</div>`
  const gender = document.querySelector('#gender')
  $(gender).after(selectOneMsgHtml);
  $(gender).parents('div.d-flex').addClass('flex-wrap')
  const genderIdentity = document.querySelector('#genderIdentity')
  $(genderIdentity).after(selectOneMsgHtml);
  $(genderIdentity).parents('div.d-flex').addClass('flex-wrap')
  const ethnicity = document.querySelector('#ethnicity')
  $(ethnicity).after(selectOneMsgHtml);
  $(ethnicity).parents('div.d-flex').addClass('flex-wrap')
  const veteranStatus = document.querySelector('#veteranStatus')
  $(veteranStatus).after(selectOneMsgHtml);
  $(veteranStatus).parents('div.d-flex').addClass('flex-wrap')
  const disability = document.querySelector('#disability')
  $(disability).after(selectOneMsgHtml);

  //Add non-existing class to help focus first invalid field
  const checkInputs = document.querySelectorAll('.form-check-input')
  checkInputs.forEach((input) => {
    input.classList.add('to-focus')
  });
  const otherInputs = document.querySelectorAll('.form-control')
  otherInputs.forEach((input) => {
    input.classList.add('to-focus')
  });
}

$("#part1Continue").click(function (e) {
  e.preventDefault(e)
  // Boostrap form validation - part1Continue **begin
  'use strict'
  // $('#submitApplication').prop('disabled',false)
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  let forms = document.querySelectorAll('.needs-validation')
  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        let firstInvalidRadio = $(form).find(".form-check-input:invalid").first();
        let firstInvalid;
        if (firstInvalidRadio != null) {
          firstInvalid = firstInvalidRadio;
        }
        window.scrollTo({
          top: 200,
          behavior: 'instant'
        });
        if (!verifyEligibility())
          firstInvalid.focus();
      }
      form.classList.add('was-validated')
    })
  // Boostrap form validation - part1Continue end

  const eligible = verifyEligibility()
  if (eligible) {
    goToStep2()
    return true
  } else {
    displayRequiredFieldsandNoEligible()
    return false
  }
})

$('#upload-Resume').click(function () {
  if ($('#uploadFile').val() === '') {
    return false
  } else {
    //Boostrap form validation - bypass checking work history and education parts
    const whInputs = document.querySelectorAll('#workHistoryBody input, #workHistoryBody  textarea, #workHistoryBody select');
    //  alert("whInputs id = " + whInputs[1].id)
    $('#companyName-0').removeAttr('required');
    whInputs.forEach((input) => {
      //   console.log("input id = " + input.id)
      if (input.id !== 'whErecruitId')
        input.removeAttribute('required')
    });
    const edInputs = document.querySelectorAll('#educationHistoryBody input, #educationHistoryBody textarea, #educationHistoryBody select');
    edInputs.forEach((input) => {
      //    console.log("input id = " + input.id)
      if (input.id !== 'edErecruitId')
        input.removeAttribute('required')
    });

    var fd = new FormData();
    var files = $('#uploadBtn')[0].files[0];
    fd.append('InternalCandidateResume', files);
    resumeuploaded = true;
    $.ajax({
      url: sessionStorage.getItem('apiHost') + 'internalCandidate/PostResume',
      type: 'post',
      data: fd,
      contentType: false,
      processData: false,
      success: function (response) {
        capFileStoreId = response.capFileStoreId
        $('#part2').hide()
        $('#part3').show()
        $('#workHistory').hide()
        $('#educationHistory').hide()
        return true
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
      },
      error: function (textStatus, errorThrown) {
        console.log(errorThrown)
      }
    })
  }
})

$('#uploadBtn').change(function () {
  $('#uploadFile').val(this.value.replace(/^.*\\/, ""))
  $('#upload-Resume').prop('disabled', false)
})

$('#continue-step3').click(function () {
  capFileStoreId = null
  $('#part2').hide()
  $('#part3').show()
  // Boostrap form validation - Work history fields
  const companyNameMsgHtml = `<div class="invalid-feedback">Please enter company name</div>`
  const companyName = document.querySelector('#companyName-0')
  $(companyName).after(companyNameMsgHtml);
  const jobCity = document.querySelector('#jobCity-0')
  $(jobCity).after(cityMsgHtml);
  const jobState = document.querySelector('#jobStatesProvince-0')
  $(jobState).after(statesProvinceMsgHtml);
  const jobPostal = document.querySelector('#jobPostal-0')
  $(jobPostal).after(ZipPostalMsgHtml);
  const jobPhoneNumber = document.querySelector('#jobPhoneNumber-0')
  jobPhoneNumber.setAttribute('pattern', '^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$')
  $(jobPhoneNumber).after(phoneMsgHtml);
  const supervisorNameMsgHtml = `<div class="invalid-feedback">Please enter supervisor name</div>`
  const supervisorName = document.querySelector('#supervisorName-0')
  $(supervisorName).after(supervisorNameMsgHtml);
  const jobTitleMsgHtml = `<div class="invalid-feedback">Please enter job title</div>`
  const jobTitle = document.querySelector('#jobTitle-0')
  $(jobTitle).after(jobTitleMsgHtml);
  const jobFromMsgHtml = `<div id="jobFromMsg-0" class="invalid-feedback">Please enter from date</div>`
  const jobFrom = document.querySelector('#jobFrom-0')
  jobFrom.setAttribute('pattern', '^(0[1-9]|1[0-2])\\/[/]?([1-2][0-9]{3})$')
  jobFrom.setAttribute('name', 'jobFrom')
  $(jobFrom).after(jobFromMsgHtml);
  const jobToMsgHtml = `<div id="jobToMsg-0" class="invalid-feedback">Please enter to date</div>`
  const jobTo = document.querySelector('#jobTo-0')
  jobTo.setAttribute('pattern', '^(0[1-9]|1[0-2])\\/[/]?([1-2][0-9]{3})$')
  jobTo.setAttribute('name', 'jobTo')
  $(jobTo).after(jobToMsgHtml);
  const jobDescriptionMsgHtml = `<div class="invalid-feedback">Please enter job description</div>`
  const jobDescription = document.querySelector('#jobDescription-0')
  $(jobDescription).after(jobDescriptionMsgHtml);
  const reasonsForLeavingMsgHtml = `<div class="invalid-feedback">Please select a reason for leaving</div>`
  const reasonsForLeaving = document.querySelector('#reasonsForLeaving-0')
  reasonsForLeaving.setAttribute('required', '')
  $(reasonsForLeaving).after(reasonsForLeavingMsgHtml);
  const ReasonForLeavingCommentsMsgHtml = `<div class="invalid-feedback">Please enter a reason for leaving comment</div>`
  const ReasonForLeavingComments = document.querySelector('#ReasonForLeavingComments-0')
  ReasonForLeavingComments.setAttribute('required', '')
  $(ReasonForLeavingComments).after(ReasonForLeavingCommentsMsgHtml);
  $("#canContact-0").parents("div.row").addClass('d-flex').removeClass('row');
  const canContact = document.querySelector('#canContact-0')
  canContact.setAttribute('required', '')
  $("#removePreviousEmployerBox").addClass('ml-2').removeClass('ml-3');

  // Boostrap form validation - Education history fields
  const educationLevelMsgHtml = `<div class="invalid-feedback">Please select a degree type</div>`
  const educationLevel = document.querySelector('#educationLevel')
  $(educationLevel).after(educationLevelMsgHtml);
  const schoolNameMsgHtml = `<div class="invalid-feedback">Please enter a school name</div>`
  const schoolName = document.querySelector('#schoolName')
  $(schoolName).after(schoolNameMsgHtml);
  const courseOfStudyMsgHtml = `<div class="invalid-feedback">Please enter a course of study</div>`
  const courseOfStudy = document.querySelector('#courseOfStudy')
  $(courseOfStudy).after(courseOfStudyMsgHtml);
  const yearsCompletedMsgHtml = `<div class="invalid-feedback">Please enter years completed</div>`
  const yearsCompleted = document.querySelector('#yearsCompleted')
  $(yearsCompleted).after(yearsCompletedMsgHtml);
  const isGraduated = document.querySelector('#isGraduated')
  $(isGraduated).after(selectMsgHtml);
})

$('#eligibilityForm').on('submit', function (event) {
  event.preventDefault()
  var eligible = verifyEligibility()
  console.log('eligible: ' + eligible)
  if (eligible) {
    goToStep2()
    // $('#step2').checked = true
  } else {
    displayRequiredFieldsandNoEligible()
  }
})

// Boostrap form validation - Set affiliatedSource field "required" is yesPreviouslyEmployed is selected  **begin
const affiliatedSource = document.querySelector('#affiliatedSource') // Added
$('#yesPreviouslyEmployed').click(function () {
  $('#affiliated').show()
  affiliatedSource.setAttribute('required', '')
})  // Added

$('#notPreviouslyEmployed').click(function () {
  $('#affiliated').hide()
  affiliatedSource.removeAttribute('required')  // Added
})
// Boostrap form validation  - Set affiliatedSource field... **end

$('#currentEmployer-0').click(function (event) {
  setCurrentEmployer(event)
})

function setCurrentEmployer(event) {
  const index = event.currentTarget.id.substring(event.currentTarget.id.indexOf('-'), event.currentTarget.id.length)
  if (event.currentTarget.checked) {
    $('#jobTo' + index)[0].setAttribute('disabled', 'disabled')
    $('#jobTo' + index)[0].value = ''
    $('#reasonsForLeaving' + index)[0].setAttribute('disabled', 'disabled')
    $('#ReasonForLeavingComments' + index)[0].setAttribute('disabled', 'disabled')
  } else {
    $('#jobTo' + index)[0].removeAttribute('disabled')
    $('#reasonsForLeaving' + index)[0].removeAttribute('disabled')
    $('#ReasonForLeavingComments' + index)[0].removeAttribute('disabled')
  }
}

function verifyEligibility() {
  if ($("#over18").is(":checked") && ($('#UsAuthorized').is(":checked") || $('#noUsAuthorized').is(":checked"))) {
    return true
  } else {
    return false
  }
}

function displayRequiredFieldsandNoEligible() {
  if ($('#under18').is(":checked")) {
    console.log('#under18')
    $('#part1').hide()
    $('#noEligible').show()
  }

}

function goToStep2() {
  // Boostrap form validation - reset form validation and set agreement attribute and classes  **begin
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  const agreedMsgHtml = `<div class="invalid-feedback" >Please check agreement box</div>`
  const hasAgreedInput = document.querySelector('#hasAgreed')
  hasAgreedInput.setAttribute('required', '')
  hasAgreedInput.classList.add('form-check-input')
  hasAgreedInput.classList.add('to-focus')
  const hasAgreedLabel = document.querySelector('.pl-3')
  $(hasAgreedLabel).after(agreedMsgHtml);
  // Boostrap form validation - reset form validation....  **end

  $.ajax({
    url: sessionStorage.getItem('apiHost') + "internal/job/dropdownList",
    dataType: 'json',
    type: 'get',
    processData: false,
    success: function (data, textStatus) {
      const t = data
      console.log(data)
      const adSource = document.getElementById('adSource')
      data.adSource.map(adSources => {
        const option = document.createElement('option')
        option.text = adSources.name
        option.value = adSources.code
        adSource.options.add(option)
      })

      const educationLevel = document.getElementById('educationLevel')
      data.educationLevel.map(dt => {
        const option = document.createElement('option')
        option.text = dt.description
        option.value = dt.id
        educationLevel.options.add(option)
      })

      const reasonsForLeaving = document.getElementById('reasonsForLeaving-0')
      data.reasonsForLeaving.map(dt => {
        const option = document.createElement('option')
        option.text = dt.description
        option.value = dt.id
        reasonsForLeaving.options.add(option)
      })

      const disability = document.getElementById('disability')
      data.disability.map(dt => {
        const option = document.createElement('option')
        option.text = dt.name
        option.value = dt.id
        disability.options.add(option)
      })
      const veteranStatus = document.getElementById('veteranStatus')
      data.veteranStatus.map(dt => {
        const option = document.createElement('option')
        option.text = dt.name
        option.value = dt.id
        veteranStatus.options.add(option)
      })

      const genderIdentity = document.getElementById('genderIdentity')
      data.genderIdentity.map(dt => {
        const option = document.createElement('option')
        option.text = dt.name
        option.value = dt.id
        genderIdentity.options.add(option)
      })

      const gender = document.getElementById('gender')
      data.gender.map(dt => {
        const option = document.createElement('option')
        option.text = dt.name
        option.value = dt.id
        gender.options.add(option)
      })

      const ethnicity = document.getElementById('ethnicity')
      data.ethnicity.map(dt => {
        const option = document.createElement('option')
        option.text = dt.name
        option.value = dt.id
        ethnicity.options.add(option)
      })
      $('#part1').hide()
      $('#part2').show()
      return true
    },
    beforeSend: function (xhr) {
      xhr.setRequestHeader('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    error: function (textStatus, errorThrown) {
      console.log(errorThrown)
    }
  })
}

function formatPhone(phone) {
  if (event.keyCode !== 8) {
    if ((event.key === undefined || !isNaN(event.key)) || phone === '') {
      var curchr = phone.length;
      var curval = phone;
      var phoneFieldId = event.currentTarget.id
      curval = curval.replace(/\D/g, '').substring(0, 10)
      if (curchr === 10 && !curval.includes('(')) {
        const areaCode = curval.substring(0, 3)
        const phonePart1 = curval.substring(3, 6)
        const phonePart2 = curval.substring(6, 10)
        $('#' + phoneFieldId).val("(" + areaCode + ")" + " " + phonePart1 + '-' + phonePart2)
        $('#' + phoneFieldId).css('background-color', 'white')
      }
    } else {
      switch (event.currentTarget.id) {
        case 'phoneNumber':
          $('#validatePhoneNumber').css('display', 'block');
          break
        case 'cellNumber':
          $('#validateCellNumber').css('display', 'block');
          break
        default:
          $('#validate' + (event.currentTarget.id.charAt(0).toUpperCase() + event.currentTarget.id.slice(1))).css('display', 'block');  //str.charAt(0).toUpperCase() + str.slice(1)
          break
      }
    }
  } else if (event.keyCode === 8) {
    if (phone.length > 0) {
      if (!isNaN(phone[phone.length - 1])) {
        hidePhoneErrorFormat(event.currentTarget.id)
      }
    } else {
      hidePhoneErrorFormat(event.currentTarget.id)
    }
  }
}

function hidePhoneErrorFormat(id) {
  switch (id) {
    case 'phoneNumber':
      $('#validatePhoneNumber').css('display', 'none');
      $('#validatePhoneNumber').css('background', 'white');
      break
    case 'cellNumber':
      $('#validateCellNumber').css('display', 'none');
      $('#validateCellNumber').css('background', 'white');
      break
    default:
      $('#validate' + (id.charAt(0).toUpperCase() + id.slice(1))).css('display', 'none');
      $('#validate' + (id.charAt(0).toUpperCase() + id.slice(1))).css('background', 'white');
  }
}

function selectRadioBtn(event) {
  if (event.code === 'Enter') {
    if (event.currentTarget.id === 'over18') $('#over18').click()
    if (event.currentTarget.id === 'under18') $('#under18').click()
    if (event.currentTarget.id === 'UsAuthorized') $('#UsAuthorized').click()
    if (event.currentTarget.id === 'noUsAuthorized') $('#noUsAuthorized').click()
    if (event.currentTarget.id === 'yesPreviouslyEmployed') $('#yesPreviouslyEmployed').click()
    if (event.currentTarget.id === 'notPreviouslyEmployed') $('#notPreviouslyEmployed').click()
    if (event.currentTarget.id === 'isCompete') $('#isCompete').click()
    if (event.currentTarget.id === 'isNotCompete') $('#isNotCompete').click()
    if (event.currentTarget.id === 'canContact-0') $('#canContact-0').click()
    if (event.currentTarget.id === 'canNotContact-0') $('#canNotContact-0').click()
  }
}

$('.btn-file')[0].setAttribute('tabindex', '0')
$('.btn-file')[0].addEventListener('focus', () => {
  if (!event.target.classList.contains('file-caption-name')) {
    $('.btn-file')[1].setAttribute('style', 'transform: scale(1.1)')
    $('.btn-file')[1].classList.add('border', 'border-primary')
  }
})
$('.btn-file')[0].addEventListener('blur', () => {
  if (!event.target.classList.contains('file-caption-name')) {
    $('.btn-file')[1].removeAttribute('style', 'transform: scale(1.1)')
    $('.btn-file')[1].classList.remove('border', 'border-primary')
  }
  if ($('#upload-Resume').is(":disabled")) {
    $('#continue-step3').focus()
  } else {
    $('#upload-Resume').focus()
  }
})
$('.btn-file')[0].addEventListener('keyup', (event) => {
  if (!event.target.classList.contains('file-caption-name')) {
    if (event.code === 'Enter') {
      $('.btn-file')[1].removeAttribute('style')
      $('.btn-file')[1].classList.remove('border', 'border-primary')
      $('#uploadBtn')[0].click()
    }
  }
})

for (const button of $('#part1Continue')) {
  button.addEventListener('focus', (event) => {
    button.setAttribute('style', 'transform: scale(1.3)')
  })
  button.addEventListener('blur', (event) => {
    button.removeAttribute('style')
  })
  button.addEventListener('keyup', (event) => {
    if (event.code === 'Enter') {
      event.preventDefault()
      const eligible = verifyEligibility()
      if (eligible) {
        goToStep2()
      } else {
        displayRequiredFieldsandNoEligible()
      }
    }
  })
}
const submitApplication = $('#submitApplication')
for (const element of submitApplication) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('blur', () => {
    element.removeAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('keyup', (event) => {
    if (event.code === 'Enter') {
      $('#submitApplication').click()
    }
  })
}

for (const element of $('input[type=checkbox]')) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.3)')
  })

  element.addEventListener('blur', () => {
    element.removeAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('keyup', (event) => {
    event.preventDefault()
    if (event.code === 'Enter') {
      if (event.currentTarget.id === 'noMiddleName') $('#noMiddleName').click()
      if (event.currentTarget.id === 'noPreviousEmployer') $('#noPreviousEmployer').click()
      if (event.currentTarget.id === 'hasAgreed') $('#hasAgreed').click()
      if (event.currentTarget.id === 'currentEmployer-0') $('#currentEmployer-0').click()
      if (event.currentTarget.id === 'tempAgency-0') $('#tempAgency-0').click()
    }
  })
}

for (const element of $('input')) {
  element.addEventListener('focus', () => {
    element.classList.add('border', 'border-primary')
  })

  element.addEventListener('blur', () => {
    element.classList.remove('border', 'border-primary')
  })
}

for (const element of $('select')) {
  element.addEventListener('focus', () => {
    element.classList.add('border', 'border-primary')
  })

  element.addEventListener('blur', (event) => {
    // if(element.id === 'adSource' && !$('#workHistory').is(':hidden')) $('#noPreviousEmployer').focus()
    element.classList.remove('border', 'border-primary')
  })

  // element.addEventListener('change', (event) => {
  //   if(capFileStoreId !== null) {
  //     $('#hasAgreed').focus()
  //   }
  // })
}

for (const element of $('#continue-step3')) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.1)')
  })
  element.addEventListener('blur', () => {
    element.removeAttribute('style', 'transform: scale(1.1)')
  })
  element.addEventListener('keyup', (event) => {
    if (event.code === 'Enter') {
      element.removeAttribute('style')
      element.click()
    }
  })
}

for (const element of $('#upload-Resume')) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('blur', () => {
    element.removeAttribute('style')
  })
  element.addEventListener('keyup', (event) => {
    if (event.code === 'Enter') {
      element.removeAttribute('style')
      element.click()
    }
  })
}

$('#emailAddress').change(function () {
  const re = /\S+@\S+\.\S+/
  let match = false
  match = re.test($('#emailAddress').val())
  if (!match) {
    $('#eligibilityMsg').text('Invalid Email')
    $('#eligibilityMsg').show()
    $('#emailAddress').css('background-color', 'pink')
  } else {
    $('#eligibilityMsg').hide()
    $('#emailAddress').css('background-color', 'white')
  }
})

$('#jobFrom-0').keyup(function (event) {
  formatDate(event)
})

$('#jobTo-0').keyup(function (event) {
  formatDate(event)
})

$('#hasAgreed').click(function () {
  if (!$('#hasAgreed').is(":checked")) {
    $('#submitApplication').prop('disabled', true)
  } else {
    $('#submitApplication').prop('disabled', false)
  }
})
$('#cellNumber').keyup(function (event) {
  formatPhone(event.currentTarget.value)
  if (event.currentTarget.value !== '')
    $('#cellOrPhoneMsg1').css("display", "none")
  else {
    if ($('#phoneNumber').val() === '')
      $('#cellOrPhoneMsg1').css("display", "block")
  }
  let pattern = $('#cellNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test($('#cellNumber').val()))
    $('#validateCellNumber').css('display', 'none')
});

$('#phoneNumber').keyup(function (event) {
  formatPhone(event.currentTarget.value)
  if (event.currentTarget.value !== '')
    $('#cellOrPhoneMsg2').css("display", "none")
  else {
    if ($('#cellNumber').val() === '')
      $('#cellOrPhoneMsg2').css("display", "block")
  }
  let pattern = $('#cellNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test($('#phoneNumber').val()))
    $('#validatePhoneNumber').css('display', 'none');
});

//Boosstrap form valoidation - only one phone filled is valid begin
$('#cellNumber').change(function (event) {
  //  alert("cellNumber entered")
  $('#phoneNumber').removeAttr('required')
  let pattern = $('#cellNumber').attr("pattern")
//  alert("pattern = " + pattern)
  let regex = new RegExp(pattern);
  if (regex.test($('#cellNumber').val())) {
    $('#validateCellNumber').css('display', 'none')
    if ($('#phoneNumber').val() === '')
      $('#cellOrPhoneMsg2').css("display", "none")
    //   $('#cellNumber').css('background', 'white');
  } else if ($('#cellNumber').val() !== '')
    $('#validateCellNumber').css('display', 'block')
});

$('#phoneNumber').change(function (event) {
  //   alert("phoneNumber entered")
  $('#cellNumber').removeAttr('required')
  let pattern = $('#cellNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test($('#phoneNumber').val())) {
    $('#validatePhoneNumber').css('display', 'none');
    if ($('#cellNumber').val() === '')
      $('#cellOrPhoneMsg1').css("display", "none")
    //  $('#phoneNumber').css('background', 'white');
  } else if ($('#phoneNumber').val() !== '')
    $('#validatePhoneNumber').css('display', 'block')
});

//Boosstrap form valoidation - only one phone filled is valid end

$('#jobPhoneNumber-0').keyup(function (event) {
  jobPhoneKeyup(event)
})

function jobPhoneKeyup(event) {
  formatPhone(event.currentTarget.value)
  let id = event.currentTarget.id
  let index = id.substring(id.indexOf("-") + 1)
  // alert('#phoneMsgDisplay-' + index)
  if (event.currentTarget.value !== '')
    $('#phoneMsgDisplay-' + index).css("display", "none")
  else
    $('#phoneMsgDisplay-' + index).css("display", "block")
  let pattern = $('#cellNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test(event.currentTarget.value))
    $('#validateJobPhoneNumber-' + index).css('display', 'none');
}

$('#jobPhoneNumber-0').change(function (event) {
  validateJobPhone(event)
});

function validateJobPhone(event) {
  let id = event.currentTarget.id
  let index = id.substring(id.indexOf("-") + 1)
  let pattern = $('#cellNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test(event.currentTarget.value)) {
    $('#validateJobPhoneNumber-' + index).css('display', 'none');
  } else
    $('#validateJobPhoneNumber-' + index).css('display', 'block');
}

$('#noMiddleName').click(function () {
  if ($('#noMiddleName').is(":checked")) {
    $('#middleName').val('')
    $('#middleName').css('background-color', 'none')
    $('#middleName').prop('disabled', true)
  } else {
    $('#middleName').prop('disabled', false)
  }
})

$('#noPreviousEmployer').click(function () {
  if ($('#noPreviousEmployer').is(":checked")) {
    $('#companyName-0').prop('disabled', true)
    $('#jobCity-0').prop('disabled', true)
    $('#jobStatesProvince-0').prop('disabled', true)
    $('#jobPostal-0').prop('disabled', true)
    $('#jobPhoneNumber-0').prop('disabled', true)
    $('#jobTitle-0').prop('disabled', true)
    $('#jobFrom-0').prop('disabled', true)
    $('#jobTo-0').prop('disabled', true)
    $('#supervisorName-0').prop('disabled', true)
    $('#currentEmployer-0').prop('disabled', true)
    $('#tempAgency-0').prop('disabled', true)
    $('#jobDescription-0').prop('disabled', true)
    $('#reasonsForLeaving-0').prop('disabled', true)
    $('#ReasonForLeavingComments-0').prop('disabled', true)
    $('#canContact-0').prop('disabled', true)
    $('#canNotContact-0').prop('disabled', true)
    $('#addEmployer-0').hide();
  } else {
    $('#companyName-0').prop('disabled', false)
    $('#jobCity-0').prop('disabled', false)
    $('#jobStatesProvince-0').prop('disabled', false)
    $('#jobPostal-0').prop('disabled', false)
    $('#jobPhoneNumber-0').prop('disabled', false)
    $('#jobTitle-0').prop('disabled', false)
    $('#jobFrom-0').prop('disabled', false)
    $('#jobTo-0').prop('disabled', false)
    $('#supervisorName-0').prop('disabled', false)
    $('#currentEmployer-0').prop('disabled', false)
    $('#tempAgency-0').prop('disabled', false)
    $('#jobDescription-0').prop('disabled', false)
    $('#reasonsForLeaving-0').prop('disabled', false)
    $('#ReasonForLeavingComments-0').prop('disabled', false)
    $('#canContact-0').prop('disabled', false)
    $('#canNotContact-0').prop('disabled', false)
    $('#addEmployer-0').show();
  }
})

$('#adSource').change(function () {
  console.log('ad source changed: ' + $('#adSource')[0].value)
  if ($('#adSource')[0].value === 'IEE') {
    $('#referralBox').show();
    $('#referral').attr('required', true);
  } else {
    $('#referralBox').hide();
    $('#referral').removeAttr('required');
  }
})

$('#submitApplication').click(function (e) {
  e.preventDefault(e)

  // Boostrap form validation - #submitApplication  **begin
  let valid = false
  // console.log('valid1: ' + valid)
  // alert("cellNumber = " + $('#cellNumber').val() + "  phone number = " + $('#phoneNumber').val())
  if ($('#cellNumber').val() === '' && $('#phoneNumber').val() === '') {
    // Boostrap form validation - replaced with Boostrap validation  **begin 2
    let cellNumber
    $('#cellNumber').attr('required', '')
    $('#cellOrPhoneMsg1').css("display", "block")
    $('#phoneNumber').attr('required', '')
    $('#cellOrPhoneMsg2').css("display", "block")
    $('#validatePhoneNumber').css('display', 'none');
    $('#validateCellNumber').css('display', 'none');
  }
  const whPhones = document.querySelectorAll("input[name='jobPhoneNumber']")
  whPhones.forEach((phone) => {
    if (phone.value === '') {
      let id = phone.id
      let idx = id.substring(id.indexOf("-") + 1)
      $('#validateJobPhoneNumber-' + idx).css('display', 'none');
      $('#phoneMsgDisplay-' + idx).css("display", "block")
    }
  });
  const jobFroms = document.querySelectorAll("input[name='jobFrom']")
  jobFroms.forEach((from) => {
    if ($(from).val() === "") {
      let msgId = from.nextElementSibling.id
      //  console.log('msgId = ' + msgId)
      $('#' + msgId).removeAttr('style')
      $('#' + msgId).text('Please enter from date')
    }
  })
  const jobTos = document.querySelectorAll("input[name='jobTo']")
  jobTos.forEach((to) => {
    if ($(to).val() === "") {
      let msgId = to.nextElementSibling.id
      //  console.log('msgId = ' + msgId)
      $('#' + msgId).removeAttr('style')
      $('#' + msgId).text('Please enter to date')
    }
  })

  let firstInvalidJobDate
  let targetDate = 0
  if (document.querySelectorAll('.invalidJobDate').length > 0) {
    firstInvalidJobDate = $('#applicationForm').find(".invalidJobDate").first();
    targetDate = firstInvalidJobDate.offset().top - 130;
    //  console.log("target date = " + targetDate);
  }
  let firstCheckDone = false
  'use strict'
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  let forms = document.querySelectorAll('.needs-validation')
  forms[0][18].pattern = "^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$"
  forms[0][17].pattern = "^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$"
  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        let firstInvalid = $(form).find(".to-focus:invalid").first();
        const target = firstInvalid.offset().top - 130;
        //alert("target = " + target);
        window.scrollTo({
          top: target,
          behavior: 'instant'
        });
        firstInvalid.focus();
      } else {
        valid = true;
      }
      form.classList.add('was-validated')
    })
  let tempCellPhone
  let tempPhone
  if ($('#cellNumber').val() === '' && $('#phoneNumber').val() === '') {
    valid = false
  } else {
    tempPhone = document.getElementById('phoneNumber').value.trim().replace("+", "").replace("(", "").replace(")", "").replace("-", "").split('')
    tempPhone = tempPhone.filter(function (ele) {
      return ele !== ' ';
    })
    tempPhone = tempPhone.join(",").replaceAll(",", "")
    tempCellPhone = document.getElementById('cellNumber').value.trim().replace("+", "").replace("(", "").replace(")", "").replace("-", "").split('')

    tempCellPhone = tempCellPhone.filter(function (ele) {
      return ele !== ' ';
    })
    tempCellPhone = tempCellPhone.join(",").replaceAll(",", "")

  }
  const invalidJobDates = document.querySelectorAll('.invalidJobDate')
  invalidJobDates.forEach((jobDate) => {
    $(jobDate).css('border-color', '#dc3545')
    $(jobDate).css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
    valid = false
  });
  if (!valid && firstCheckDone) {
    firstInvalidJobDate = $('#applicationForm').find(".invalidJobDate").first();
    targetDate = firstInvalidJobDate.offset().top - 130;
    window.scrollTo({
      top: targetDate,
      behavior: 'instant'
    });
    firstInvalidJobDate.focus();
  }

  console.log('valid2: ' + valid)
  if (valid) {
    $('#submitApplication').prop('disabled', true)
    var tempWH = []
    var tempEH = []
    var whDetails = null
    var ehDetails = null
    if (!resumeuploaded) {
      if (!$('#noPreviousEmployer').is(":checked")) {
        $('.workHistoryItem').each(function (index) {
          var $whItem = $(this)
          if ($whItem.children('#whErecruitId').val().length === 0) {
            const endDate = $whItem.find('#jobTo-' + index).val().trim() === '' ?
              (new Date().getMonth() < 9 ? '0' + (new Date().getMonth() + 1).toString() + '/'
                : new Date().getMonth() + 1 + '/').toString()
              + new Date().getFullYear() : $whItem.find('#jobTo-' + index).val().trim()
            whDetails = {
              companyName: $whItem.find('#companyName-' + index).val().trim(),
              city: $whItem.find('#jobCity-' + index).val().trim(),
              StateProvince: $whItem.find('#jobStatesProvince-' + index).val().trim(),
              postalCode: $whItem.find('#jobPostal-' + index).val().trim(),
              phoneNumber: $whItem.find('#jobPhoneNumber-' + index).val().trim(),
              jobTitle: $whItem.find('#jobTitle-' + index).val().trim(),
              startDate: $whItem.find('#jobFrom-' + index).val().trim(),
              endDate: endDate,
              supervisorName: $whItem.find('#supervisorName-' + index).val().trim(),
              currentEmployerFlag: $whItem.find('#currentEmployer-' + index)[0].checked,
              tempAgency: $whItem.find('#tempAgency-' + index)[0].checked,
              jobDescription: $whItem.find('#jobDescription-' + index).val().trim(),
              reasonId: $whItem.find('#reasonsForLeaving-' + index).val().trim(),
              ReasonForLeavingComments: $whItem.find('#ReasonForLeavingComments-' + index).val().trim(),
              contactFlag: $whItem.find('#canContact-' + index)[0].checked
            }
            console.log(whDetails)
            tempWH.push(whDetails)
            console.log(tempWH)
          }
        })
      }
      if (!$('#educationHistory')[0].hidden) {
        console.log(educationHistory)
        $('.edHistoryItem').each(function (i) {
          var $edItem = $(this)
          if ($edItem.children('#edErecruitId').val().length === 0) {
            ehDetails = {
              educationLevelId: $edItem.find('#educationLevel').val().trim(),
              schoolName: $edItem.find('#schoolName').val().trim(),
              courseOfStudy: $edItem.find('#courseOfStudy').val().trim(),
              graduated: $edItem.find('#isGraduated').val().trim()
            }
            tempEH.push(ehDetails)
            console.log(tempWH)
          }
        })
      }
    }


    candidate = {
      applicationSource: "CAP",
      jobErecruitId: Number(sessionStorage.getItem('jobId')),
      peopleSoftId: candidateId,
      firstName: document.getElementById('firstName').value === '' ? null : document.getElementById('firstName').value.trim(),
      middleName: document.getElementById('middleName').value === '' ? null : document.getElementById('middleName').value.trim(),
      noMiddleName: document.getElementById('noMiddleName').value === 'on',
      lastName: document.getElementById('lastName').value === '' ? null : document.getElementById('lastName').value.trim(),
      emailAddress: document.getElementById('emailAddress').value === '' ? null : document.getElementById('emailAddress').value.trim(),
      address1: document.getElementById('address1').value === '' ? null : document.getElementById('address1').value.trim(),
      address2: document.getElementById('address2').value === '' ? null : document.getElementById('address2').value.trim(),
      city: document.getElementById('city').value === '' ? null : document.getElementById('city').value.trim(),
      stateProvince: document.getElementById('statesProvince').value = '' ? null : document.getElementById('statesProvince').value.trim(),
      postalCode: document.getElementById('ZipPostal').value === '' ? null : document.getElementById('ZipPostal').value.trim(),
      linkedInUrl: document.getElementById('linkedInUrl').value === '' ? null : document.getElementById('linkedInUrl').value.trim(),
      cellPhone: tempCellPhone,
      homePhone: tempPhone,
      adSourceId: document.getElementById('adSource').value === '' ? null : document.getElementById('adSource').value.trim(),
      eligibilityFlag: true,
      ageFlag: true,
      agreementAcknowledgement: true,
      resumeFileStoreId: capFileStoreId,
      nonCompete: document.getElementById('isCompete').checked,
      gender: document.getElementById('gender').value === '' ? null : document.getElementById('gender').value.trim(),
      genderIdentity: document.getElementById('genderIdentity').value === '' ? null : document.getElementById('genderIdentity').value.trim(),
      ethnicityId: document.getElementById('ethnicity').value === '' ? null : document.getElementById('ethnicity').value.trim(),
      veteranStatusId: document.getElementById('veteranStatus').value === '' ? null : document.getElementById('veteranStatus').value.trim(),
      disabilityId: document.getElementById('disability').value === '' ? null : document.getElementById('disability').value.trim(),
      referredBy: document.getElementById('referral').value === '' ? null : document.getElementById('referral').value.trim(),
      workHistory: tempWH,
      educationHistory: tempEH,
      previousAffiliate: document.getElementById('affiliatedSource').value === '' ? null : document.getElementById('affiliatedSource').value.trim(),
      previouslyEmployedFlag: document.getElementById('yesPreviouslyEmployed').checked,
    }
    console.log('candidate: ' + candidate)
    $.ajax({
      url: sessionStorage.getItem('apiHost') + "internalCandidate/Submit",
      dataType: 'json',
      type: 'post',
      contentType: 'application/json',
      data: JSON.stringify(candidate),
      processData: false,
      success: function (data) {
        const t = data
        if (window.location.origin.includes('localhost')) {
          window.location.href = window.location.origin + '/' + sessionStorage.getItem('brandId') + '/thank-you.html';
        } else {
          window.location.href = window.location.origin + '/jobs/' + sessionStorage.getItem('brandId') + '/thank-you';
        }
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
      },
      error: function (textStatus, errorThrown) {
        console.log(errorThrown)
      }
    })
  }
})

function returnToSearch() {
  window.location.href = window.location.origin + '/jobs/' + sessionStorage.getItem('brandId')
}

function duplicateWorkHistory() {
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  $('#cellOrPhoneMsg1').css("display", "none")
  $('#cellOrPhoneMsg2').css("display", "none")
  //Boostrap from validation - reset form validation **end

  const original = document.getElementById('previousEmployer-0');
  const clone = original.cloneNode(true); // "deep" clone
  clone.id = "previousEmployer-" + ++workCounter; // there can only be one element with an ID
  clone.children[1].children[1].children[0].id = "removePreviousEmployer-" + workCounter;
  console.log('clone: ')
  console.log(clone.children)
  clone.elements["companyName-0"].id = "companyName-" + workCounter
  clone.elements["companyName-" + workCounter].value = ''
  clone.elements["jobCity-0"].id = "jobCity-" + workCounter
  clone.elements["jobCity-" + workCounter].value = ''
  clone.elements["jobStatesProvince-0"].id = "jobStatesProvince-" + workCounter
  clone.elements["jobStatesProvince-" + workCounter].value = ''
  clone.elements["jobPostal-0"].id = "jobPostal-" + workCounter
  clone.elements["jobPostal-" + workCounter].value = ''
  clone.elements["jobPhoneNumber-0"].id = "jobPhoneNumber-" + workCounter
  clone.elements["jobPhoneNumber-" + workCounter].value = ''
  clone.elements["jobPhoneNumber-" + workCounter].addEventListener('keyup', (event) => {
    jobPhoneKeyup(event)
  })
  clone.elements["jobPhoneNumber-" + workCounter].addEventListener('change', (event) => {
    validateJobPhone(event)
  })
  clone.elements["jobPhoneNumber-" + workCounter].nextElementSibling.nextElementSibling.id = 'validateJobPhoneNumber-' + workCounter
  clone.elements["jobPhoneNumber-" + workCounter].nextElementSibling.id = 'phoneMsgDisplay-' + workCounter
  clone.elements["jobTitle-0"].id = "jobTitle-" + workCounter
  clone.elements["jobTitle-" + workCounter].value = ''
  clone.elements["jobFrom-0"].id = "jobFrom-" + workCounter
  clone.elements["jobFrom-" + workCounter].value = ''
  clone.elements["jobFrom-" + workCounter].addEventListener('keyup', event => {
    formatDate(event)
  })
  clone.elements["jobFrom-" + workCounter].addEventListener('change', event => {
    validateFromDate(event)
  })
  clone.elements["jobFrom-" + workCounter].nextElementSibling.id = 'jobFromMsg-' + workCounter
  clone.elements["jobTo-0"].id = "jobTo-" + workCounter
  clone.elements["jobTo-" + workCounter].value = ''
  clone.elements["jobTo-" + workCounter].addEventListener('keyup', event => {
    formatDate(event)
  })
  clone.elements["jobTo-" + workCounter].addEventListener('change', event => {
    validateToDate(event)
  })
  clone.elements["jobTo-" + workCounter].nextElementSibling.id = 'jobToMsg-' + workCounter
  clone.elements["supervisorName-0"].id = "supervisorName-" + workCounter
  clone.elements["supervisorName-" + workCounter].value = ''
  clone.elements["currentEmployer-0"].id = "currentEmployer-" + workCounter
  clone.elements["currentEmployer-" + workCounter].checked = false
  clone.elements["currentEmployer-" + workCounter].addEventListener('click', event => {
    setCurrentEmployer(event)
  })
  clone.elements["currentEmployer-" + workCounter].addEventListener('focus', () => {
    clone.elements["currentEmployer-" + workCounter].setAttribute('style', 'transform: scale(1.3)')
  })
  clone.elements["currentEmployer-" + workCounter].addEventListener('blur', () => {
    clone.elements["currentEmployer-" + workCounter].removeAttribute('style', 'transform: scale(1.3)')
  })
  clone.elements["currentEmployer-" + workCounter].addEventListener('keyup', (event) => {
    event.preventDefault()
    if (event.code === 'Enter') {
      clone.elements["currentEmployer-" + workCounter].checked =
        clone.elements["currentEmployer-" + workCounter].checked ? false : true
      setCurrentEmployer(event)
    }
  })

  clone.elements["tempAgency-0"].id = "tempAgency-" + workCounter
  clone.elements["tempAgency-" + workCounter].checked = false
  clone.elements["tempAgency-" + workCounter].addEventListener('focus', () => {
    clone.elements["tempAgency-" + workCounter].setAttribute('style', 'transform: scale(1.3)')
  })
  clone.elements["tempAgency-" + workCounter].addEventListener('blur', () => {
    clone.elements["tempAgency-" + workCounter].removeAttribute('style', 'transform: scale(1.3)')
  })
  clone.elements["tempAgency-" + workCounter].addEventListener('keyup', (event) => {
    event.preventDefault()
    if (event.code === 'Enter') {
      clone.elements["tempAgency-" + workCounter].checked =
        clone.elements["tempAgency-" + workCounter].checked ? false : true
    }
  })

  clone.elements["jobDescription-0"].id = "jobDescription-" + workCounter
  clone.elements["jobDescription-" + workCounter].value = ''
  clone.elements["reasonsForLeaving-0"].id = "reasonsForLeaving-" + workCounter
  clone.elements["reasonsForLeaving-" + workCounter].value = ''
  clone.elements["ReasonForLeavingComments-0"].id = "ReasonForLeavingComments-" + workCounter
  clone.elements["ReasonForLeavingComments-" + workCounter].value = '0'
  clone.elements["canContact-0"].id = "canContact-" + workCounter
  clone.elements["canContact-" + workCounter].name = "contactEmployer-radio-group2-" + workCounter
  clone.elements["canContact-" + workCounter].checked = false
  clone.elements["canContact-" + workCounter].addEventListener('keyup', event => {
    if (event.key === 'Enter') $('#canContact-' + workCounter).click()
  })
  clone.elements["canContact-" + workCounter].nextElementSibling.id = 'contactEmployerLbl-' + workCounter
  clone.elements["canContact-" + workCounter].nextElementSibling.htmlFor = "canContact-" + workCounter
  clone.elements["canNotContact-0"].id = "canNotContact-" + workCounter
  clone.elements["canNotContact-" + workCounter].name = "contactEmployer-radio-group2-" + workCounter
  clone.elements["canNotContact-" + workCounter].checked = false
  clone.elements["canNotContact-" + workCounter].nextElementSibling.id = 'doNotContactEmployerLbl-' + workCounter
  clone.elements["canNotContact-" + workCounter].nextElementSibling.htmlFor = "canNotContact-" + workCounter

  for (let i = 0; i < clone.elements.length; i++) {
    clone.elements[i].disabled = false
  }
  clone.children[1].children[1].style.display = "block"

  wrkHistory.push(clone.elements)
  document.getElementById('workHistoryBody').append(clone);
  let jobPhoneNumber = document.querySelector('#jobPhoneNumber-' + workCounter)
  jobPhoneNumber.setAttribute('pattern', '^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$')
  jobPhoneNumber.setAttribute('required', '')
  const whPhones = document.querySelectorAll("input[name='jobPhoneNumber']")
  whPhones.forEach((phone) => {
    if (phone.value === '') {
      let id = phone.id
      let idx = id.substring(id.indexOf("-") + 1)
      $('#validateJobPhoneNumber-' + idx).css('display', 'none');
      $('#phoneMsgDisplay-' + idx).css("display", "none")
    }
  });
  $('#jobFromMsg-' + workCounter).css('display', 'none');
  $('#jobToMsg-' + workCounter).css('display', 'none');
  $("#jobFrom-" + workCounter).removeClass("invalidJobDate")
  $("#jobTo-" + workCounter).removeClass("invalidJobDate")

  const jobFroms = document.querySelectorAll("input[name='jobFrom']")
  jobFroms.forEach((from) => {
    $(from).css('background-image', '')
  })
  const jobTos = document.querySelectorAll("input[name='jobTo']")
  jobTos.forEach((to) => {
    $(to).css('background-image', '')
  })
}

function duplicateEducationHistory(isNew, eduHistory) {
  //Boostrap from validation - duplicateEducationHistory reset form validation **begin
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  //Boostrap from validation - reset form validation **end

  const original = document.getElementById('previousEducation-0');
  const clone = original.cloneNode(true); // "deep" clone
  clone.id = "previousEducation-" + ++educationCounter; // there can only be one element with an ID
  clone.children[1].children[1].children[0].id = "removePreviousEducation-" + educationCounter;
  console.log('clone: ')
  console.log(clone.children)
  clone.elements['educationLevel'].value = ''
  clone.elements["schoolName"].value = ''
  clone.elements['courseOfStudy'].value = ''
  clone.elements['isGraduated'].value = ''
  for (var i = 0; i < clone.elements.length; i++) {
    clone.elements[i].disabled = false
  }
  clone.children[1].children[1].style.display = "block"
  console.log(' edErecruitId: ' + clone.elements["edErecruitId"].value)
  educationHistory.push(clone.elements);
  document.getElementById('educationHistoryBody').append(clone);
}

function deleteWorkClone(event) {
  var index = event.currentTarget.id.split('-')[1]
  var wrkItem = document.getElementById('previousEmployer-' + index)
  wrkItem.remove();
  wrkHistory.splice(index, 1)
}

function deleteSchoolClone(event) {
  var index = event.currentTarget.id.split('-')[1]
  var edItem = document.getElementById('previousEducation-' + index)
  edItem.remove();
  educationHistory.splice(index, 1)
}

function formatDate(event) {
  var curchr = event.currentTarget.value.length;
  var curval = event.currentTarget.value;
  if (curchr === 2 && event.key !== 'Backspace') {
    if (curval.at(1) === '/') {
      curval = 0 + curval.at(0)
      event.currentTarget.value = curval + "/";
    } else {
      event.currentTarget.value = curval + "/";
    }
  }
}

function validate(event) {
  if (event.currentTarget.value !== '') {
  } else {
    if (event.type !== 'keyup') {
      event.currentTarget.setAttribute('style', 'background: pink')
    }
  }
}

$('#jobFrom-0').change(function (event) {
  validateFromDate(event)
});

$('#jobTo-0').change(function (event) {
  validateToDate(event)
});

function validateFromDate(event) {
  let fromDate = event.currentTarget.value
  let fromDateId = event.currentTarget.id
  let $fromDate = $('#' + fromDateId)
  let $jobFromMsg, $jobToMsg, $toDate, toDate
  let idx = fromDateId.indexOf("-")
  if (idx > 0) {
    idx = fromDateId.substring(idx + 1)
    $jobFromMsg = $('#jobFromMsg-' + idx)
    $jobToMsg = $('#jobToMsg-' + idx)
    $toDate = $('#jobTo-' + idx)
  }
  // else{
  //   $jobFromMsg = $('#jobFromMsg')
  //   $jobToMsg = $('#jobToMsg')
  //   $toDate = $('#jobTo')
  // }
  toDate = $toDate.val()
  if (fromDate !== '') {
    if (validateJobDate(fromDate)) {
      if (toDate !== '') {
        if (compareJobDates(fromDate, toDate)) {
          $jobFromMsg.css('display', 'none');
          $jobToMsg.css('display', 'none');
          $fromDate.removeClass('invalidJobDate')
          $toDate.removeClass('invalidJobDate')
          if ($("#applicationForm").hasClass("was-validated")) {
            $fromDate.css('border-color', 'rgb(13, 110, 253)');
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $toDate.css('border-color', 'rgb(13, 110, 253)');
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
          }
        } else {
          $jobFromMsg.text('From date is greater than to date')
          $jobFromMsg.css("display", "block")
          $fromDate.addClass('invalidJobDate')
          if ($("#applicationForm").hasClass("was-validated")) {
            $fromDate.css('border-color', '#dc3545')
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
          }
        }
      }
      if (!$fromDate.hasClass("invalidJobDate"))
        $jobFromMsg.css('display', 'none');
    } else {
      $jobFromMsg.text('Invalid from date')
      $jobFromMsg.css("display", "block")
    }
  } else {
    $jobFromMsg.text('Please enter from date')
    $jobFromMsg.css("display", "block")
  }
}

function validateToDate(event) {
  let toDate = event.currentTarget.value
  let toDateId = event.currentTarget.id
  let $toDate = $('#' + toDateId)
  let $jobFromMsg, $jobToMsg, $fromDate, fromDate
  let idx = toDateId.indexOf("-")
  if (idx > 0) {
    idx = toDateId.substring(idx + 1)
    $jobFromMsg = $('#jobFromMsg-' + idx)
    $jobToMsg = $('#jobToMsg-' + idx)
    $fromDate = $('#jobFrom-' + idx)
  }
  // else{
  //   $jobFromMsg = $('#jobFromMsg')
  //   $jobToMsg = $('#jobToMsg')
  //   $fromDate = $('#jobFrom')
  // }
  fromDate = $fromDate.val()
  if (toDate !== '') {
    if (validateJobDate(toDate)) {
      if (fromDate !== '') {
        if (compareJobDates(fromDate, toDate)) {
          $jobToMsg.css('display', 'none');
          $toDate.removeClass('invalidJobDate')
          if (validateJobDate(fromDate)) {
            $jobFromMsg.css('display', 'none');
            $fromDate.removeClass('invalidJobDate')
          }
          if ($("#applicationForm").hasClass("was-validated")) {
            $toDate.css('border-color', 'rgb(13, 110, 253)');
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $fromDate.css('border-color', 'rgb(13, 110, 253)');
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
          }
        } else {
          $jobToMsg.text('To date is less than from date')
          $jobToMsg.css("display", "block")
          $toDate.addClass('invalidJobDate')
          if (document.querySelector("#applicationForm").classList.contains("was-validated")) {
            $toDate.css('border-color', '#dc3545')
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
          }
        }
      }
      if (!$toDate.hasClass("invalidJobDate"))
        $jobToMsg.css('display', 'none');
    } else {
      $jobToMsg.text('Invalid to date')
      $jobToMsg.css("display", "block")
    }
  } else {
    $jobToMsg.text('Please enter to date')
    $jobToMsg.css("display", "block")
  }
}

function validateJobDate(jobDate) {
  let pattern = $('#jobFrom-0').attr("pattern")
  let regex = new RegExp(pattern)
  if (!regex.test(jobDate))
    return false
  let jobMonthYear = jobDate.split("/")
  let jobMonth = Number(jobMonthYear[0])
  let jobYear = Number(jobMonthYear[1])
  let currDate = new Date();
  let currMonth = currDate.getMonth() + 1
  let currYear = currDate.getFullYear()
  if ((jobYear === currYear && (jobMonth > currMonth)) || (jobYear > currYear))
    return false
  else
    return true
}

function compareJobDates(fromDate, toDate) {
  let fromMonthYear = fromDate.split("/")
  let fromMonth = Number(fromMonthYear[0])
  let fromYear = Number(fromMonthYear[1])
  let toMonthYear = toDate.split("/")
  let toMonth = Number(toMonthYear[0])
  let toYear = Number(toMonthYear[1])
  if ((fromYear === toYear && (fromMonth > toMonth)) || (fromYear > toYear))
    return false
  else
    return true
}

function checkEligibilityInput(event) {

  const ageVerification = $("input[name='ageVerification-radio-group']:checked").val();
  const eligibility = $("input[name='usAuthorizationVerification-radio-group2']:checked").val();

  //Boostrap from validation - checkEligibilityInput custom message display **begin
  if ($("#under18").is(':checked'))
    $("#check-age").css("display", "block")
  else
    $("#check-age").css("display", "none")

  if ($("#noUsAuthorized").is(':checked'))
    $("#check-auth").css("display", "block")
  else
    $("#check-auth").css("display", "none")
  //Boostrap from validation - checkEligibilityInput custom message display **end

  if (ageVerification === "true" && eligibility === "true") {
    $("#part1Continue").prop('disabled', false);
    console.log("Enabled");
  } else {
    console.log("Disabled");
    $("#part1Continue").prop('disabled', true);
  }
}

document.addEventListener("keypress", function (event) {
  // If the user presses the "Enter" key on the keyboard
  if (event.key === "Enter") {
    // Cancel the default action, if needed
    event.preventDefault();

  }
});
